// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const pending = "Progress__pending__44kMI";
export const confirmed = "Progress__confirmed__rMm1X";
export const earned = "Progress__earned__24TFH";
export const expired = "Progress__expired__d2Vr1";
export const progress = "Progress__progress__kUg9-";
export const progressInner = "Progress__progressInner__su+ir";
export const circle = "Progress__circle__AHiGI";